// Phase 7 R2 — submit a draft PO via RPC.
// Atomic: flips PO to 'submitted', mirrors linked parts_lines from
// procurement_status='not_ordered' → 'ordered', writes po_submitted event.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SubmitPurchaseOrderArgs {
  shopId: string;
  purchaseOrderId: string;
}

export function useSubmitPurchaseOrder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ shopId, purchaseOrderId }: SubmitPurchaseOrderArgs) => {
      const { data, error } = await (supabase as any).rpc('submit_purchase_order', {
        p_shop_id: shopId,
        p_purchase_order_id: purchaseOrderId,
      });
      if (error) throw error;
      return data as string;
    },
    onSuccess: (_data, vars) => {
      // Invalidate every surface that mirrors procurement state.
      qc.invalidateQueries({ queryKey: ['purchase-orders'] });
      qc.invalidateQueries({ queryKey: ['purchase-order', vars.purchaseOrderId] });
      qc.invalidateQueries({ queryKey: ['parts-lines'] });
      qc.invalidateQueries({ queryKey: ['ticket-po-linked-parts-lines'] });
    },
  });
}
